import { useEffect, useState } from 'react'

import LBPageNav from './components/LBPageNav/LBPageNav'
import LiveboardRoutes from './LiveboardRoutes'
import { getTenantConfig } from './util/LiveboardUtil'
import { useAuth } from '@/providers/auth.provider'
import Header from '@/layout/components/Header'
import { BarChartOutlined } from '@ant-design/icons'
import Permission from '@/components/Permission'
import { useNavigate } from 'react-router-dom'
import { upperCase } from 'lodash'

export default function LiveboardLayout() {
  const { user } = useAuth()
  const [config, setconfig] = useState(null)

  const navigate = useNavigate()

  const init = async () => {
    const data = await getTenantConfig(user?.company?.id)
    const firstModuleKey = data?.company?.modules?.[0]?.key
    if (firstModuleKey) {
      navigate(upperCase(firstModuleKey))
    }
    setconfig(data)
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <Permission roles={['ADMIN']}>
      <>
        <Header
          icon={<BarChartOutlined className="icon" />}
          title={'My Liveboard'}
          background="linear-gradient(181.35deg, #51995C 18.45%, rgba(101, 191, 115, 0.9) 98.85%)"
        />
        <div style={{ padding: '0 32px', paddingTop: '24px' }}>
          {config !== null && <LBPageNav config={config} />}
          <LiveboardRoutes />
        </div>
      </>
    </Permission>
  )
}
